import { jsx as _jsx } from "react/jsx-runtime";
import DeleverageSetup from "./DeleverageSetup";
import LossPolicySetup from "./LossPolicySetup";
import PartialSetup from "./PartialSetup";
import RwaSetup from "./RwaSetup";
const StrategySetup = ({ result, underlying, title, }) => {
    switch (result.strategy) {
        case "loss-policy":
            return result.setup ? (_jsx(LossPolicySetup, { setup: result.setup, underlying: underlying, title: title })) : null;
        case "partial":
        case "wallet-partial":
            return result.setup ? (_jsx(PartialSetup, { setup: result.setup, title: title })) : null;
        case "deleverage":
            return result.setup ? (_jsx(DeleverageSetup, { setup: result.setup, title: title })) : null;
        case "rwa-via-stablecoins":
            return result.setup ? (_jsx(RwaSetup, { setup: result.setup, title: title })) : null;
        default:
            return null;
    }
};
export default StrategySetup;
